import type { PortalAccount } from "../../store/portalAuthApi";

export type PortalAccountsViewState =
  | { status: "switching" }
  | { status: "error"; message: string }
  | { status: "loading" }
  | { status: "empty" }
  | { status: "chooseAccount"; accounts: PortalAccount[] }
  | { status: "ready"; account: PortalAccount };

type ViewInputs = {
  accounts: PortalAccount[] | undefined;
  currentCustomerId: string | null;
  pending: boolean;
  loadError: string | null;
};

export const portalAccountsView = {
  derive({ accounts, currentCustomerId, pending, loadError }: ViewInputs): PortalAccountsViewState {
    if (pending) return { status: "switching" };
    if (loadError !== null) return { status: "error", message: loadError };
    if (!accounts) return { status: "loading" };
    if (!accounts.length) return { status: "empty" };
    const account = accounts.find((account) => account.customerId === currentCustomerId);
    return account ? { status: "ready", account } : { status: "chooseAccount", accounts };
  },
};
